/* =============================================
   Lorianne — Collection Page interactive JS
   Loaded via <script src="{{ 'lrn-collection.js' | asset_url }}" defer>
   Handles: filter drawer, view switch, category filter, color hex mapping,
            AJAX filter submit, load-more/infinite scroll, card hover video,
            wishlist, color swatches navigation.
   ============================================= */
(function () {
  'use strict';

  function initAll() {

    /* ── Color swatches navigation ── */
    document.body.addEventListener('click', function (e) {
      var sw = e.target.closest('.lrn-swatch[data-href]');
      if (!sw) return; e.preventDefault(); e.stopPropagation();
      window.location.href = sw.getAttribute('data-href');
    });
    document.body.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var sw = e.target.closest('.lrn-swatch[data-href]');
      if (!sw) return; e.preventDefault();
      window.location.href = sw.getAttribute('data-href');
    });

    /* ── Card hover video ── */
    document.querySelectorAll('.lrn-card--shadow').forEach(function (card) {
      var hv = card.querySelector('.lrn-card__hover-video');
      if (!hv) return;
      var play = function () { var p = hv.play(); if (p && typeof p.catch === 'function') p.catch(function () {}); };
      var pause = function () { try { hv.pause(); hv.currentTime = 0; } catch (e) {} };
      card.addEventListener('mouseenter', play); card.addEventListener('focusin', play);
      card.addEventListener('mouseleave', pause); card.addEventListener('focusout', pause);
    });

    /* ── Wishlist toggle ── */
    document.querySelectorAll('.lrn-wish-btn, .lrn-product-card__wish').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault(); btn.classList.toggle('lrn-wished');
        var path = btn.querySelector('path');
        if (path) path.setAttribute('fill', btn.classList.contains('lrn-wished') ? '#8B6B43' : 'none');
      });
    });

    /* ── Load-more / infinite scroll ── */
    function setupLoadMore() {
      var btn = document.querySelector('[data-lrn-load-more]');
      var grid = document.querySelector('[data-lrn-grid]');
      if (!btn || !grid) return;
      if (btn.__autoBound) return;
      btn.__autoBound = true;
      function setIdleLabel() { var label = btn.querySelector('[data-lrn-load-label]'); if (label) label.textContent = 'Reveal Next'; }
      function loadNext() {
        var nextUrl = btn.getAttribute('data-next-url');
        if (!nextUrl || btn.disabled) return Promise.resolve();
        btn.disabled = true;
        var label = btn.querySelector('[data-lrn-load-label]');
        if (label) label.textContent = 'Loading…';
        return fetch(nextUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var newGrid = doc.querySelector('[data-lrn-grid]');
            if (newGrid) {
              Array.from(newGrid.children).forEach(function (card) { grid.appendChild(card); });
              if (typeof window.__lrnColorAll === 'function') window.__lrnColorAll();
              if (typeof window.__lrnInterleave === 'function') window.__lrnInterleave();
            }
            var nextBtn = doc.querySelector('[data-lrn-load-more]');
            if (nextBtn) { btn.setAttribute('data-next-url', nextBtn.getAttribute('data-next-url')); }
            else { if (btn.__autoIO) btn.__autoIO.disconnect(); var wrap = btn.closest('[data-lrn-load-wrap]'); if (wrap) wrap.remove(); return; }
            var shownEl = document.querySelector('[data-lrn-shown]');
            var totalEl = document.querySelector('[data-lrn-total]');
            var statusEl = document.querySelector('[data-lrn-load-status]');
            var newShown = grid.querySelectorAll(':scope > a, :scope > .lrn-card').length;
            if (shownEl) shownEl.textContent = newShown;
            if (totalEl && statusEl) { var remain = parseInt(totalEl.textContent, 10) - newShown; statusEl.textContent = remain > 0 ? remain + ' more' : 'All shown'; }
            setIdleLabel(); btn.disabled = false;
            if (btn.getAttribute('data-auto-load') !== 'false') {
              requestAnimationFrame(function () {
                var rect = btn.getBoundingClientRect();
                if (rect.top < window.innerHeight + 400 && !btn.disabled && btn.getAttribute('data-next-url')) loadNext();
              });
            }
          }).catch(function () { if (label) label.textContent = 'Retry'; btn.disabled = false; });
      }
      btn.addEventListener('click', function () { loadNext(); });
      var autoLoadEnabled = btn.getAttribute('data-auto-load') !== 'false';
      if (autoLoadEnabled && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) { if (entry.isIntersecting && !btn.disabled) loadNext(); });
        }, { rootMargin: '400px 0px' });
        io.observe(btn); btn.__autoIO = io;
      }
    }
    setupLoadMore();
    window.__lrnSetupLoadMore = setupLoadMore;

    /* ── Filter drawer + view switch + interleave + AJAX filters ── */
    (function () {
      var root = document.documentElement;
      var openers = document.querySelectorAll('[data-coll-open]');
      var closers = document.querySelectorAll('[data-coll-close]');
      if (!openers.length) return;
      function open() { root.classList.add('lrn-coll-open'); }
      function close() { root.classList.remove('lrn-coll-open'); }
      openers.forEach(function (b) { b.addEventListener('click', open); });
      closers.forEach(function (b) { b.addEventListener('click', close); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('lrn-coll-open')) close(); });

      var viewBtns = document.querySelectorAll('.lrn-view-btn');
      var grid = document.querySelector('.lrn-coll-grid');
      viewBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var cols = btn.getAttribute('data-cols');
          viewBtns.forEach(function (b) { b.classList.remove('lrn-view-btn--active'); b.style.background = 'transparent'; b.style.color = ''; });
          btn.classList.add('lrn-view-btn--active'); btn.style.background = '#1A1410'; btn.style.color = '#FAF6F0';
          if (grid) { grid.setAttribute('data-cols', cols); grid.style.gridTemplateColumns = 'repeat(' + cols + ', 1fr)'; }
        });
      });

      /* Stride-based interleave */
      function interleaveGridByType() {
        var grid = document.querySelector('[data-lrn-grid]');
        if (!grid || grid.getAttribute('data-lrn-interleave') !== 'true') return;
        var cards = Array.from(grid.querySelectorAll(':scope > a'));
        if (cards.length < 4) return;
        var groups = {}, order = [];
        cards.forEach(function (c) { var t = (c.getAttribute('data-product-type') || '').trim() || '_'; if (!groups[t]) { groups[t] = []; order.push(t); } groups[t].push(c); });
        if (order.length < 2) return;
        var scored = [];
        order.forEach(function (t) { var g = groups[t]; var n = g.length; g.forEach(function (c, i) { scored.push({ card: c, score: (i + 0.5) / n }); }); });
        scored.sort(function (a, b) { return a.score - b.score; });
        scored.forEach(function (item) { grid.appendChild(item.card); });
      }
      interleaveGridByType();
      window.__lrnInterleave = interleaveGridByType;

      /* Active category chip from URL path */
      function renderActiveCategoryChip() {
        var toolbar = document.querySelector('.lrn-toolbar');
        if (!toolbar) return;
        var leftBox = toolbar.querySelector('div');
        if (!leftBox) return;
        leftBox.querySelectorAll('[data-lrn-cat-chip]').forEach(function (n) { n.remove(); });
        var m = window.location.pathname.match(/^\/collections\/[^\/]+\/([^\/?#]+)/);
        if (!m) return;
        var rawSeg = decodeURIComponent(m[1]);
        if (!rawSeg) return;
        var handles = rawSeg.split('+');
        function findLabel(handle) {
          var all = document.querySelectorAll('.lrn-cat-child__input');
          for (var i = 0; i < all.length; i++) {
            var v = all[i].value;
            var vh = String(v).toLowerCase().replace(/[^\w\s-]/g, '').replace(/\s+/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '');
            if (vh === handle) return v;
          }
          return handle.split('-').map(function (w) { return w.charAt(0).toUpperCase() + w.slice(1); }).join(' ');
        }
        var basePath = '/collections/' + window.location.pathname.split('/')[2];
        handles.forEach(function (h) {
          var label = findLabel(h);
          var display = String(label).replace(/^Custom\s+/i, '').toUpperCase();
          var a = document.createElement('a');
          a.setAttribute('data-lrn-cat-chip', '');
          a.href = basePath + window.location.search;
          a.className = 'lrn-chip';
          a.style.cssText = 'display:inline-flex;align-items:center;gap:10px;padding:8px 14px;background:#1A1410;color:#FAF6F0;border:1px solid #1A1410;border-radius:999px;font-family:var(--font-body);font-size:10px;letter-spacing:0.28em;text-transform:uppercase;text-decoration:none;';
          a.innerHTML = display + ' <span style="opacity:0.85;font-size:14px;line-height:0.7;">×</span>';
          leftBox.appendChild(a);
        });
      }
      renderActiveCategoryChip();
      window.__lrnRenderCatChip = renderActiveCategoryChip;

      /* Category filter: parent/child + color hex mapping */
      (function () {
        var COLOR_HEX = {
          'black':'#000000','white':'#FFFFFF','red':'#E53935','blue':'#1E88E5','green':'#43A047',
          'yellow':'#FFEB3B','orange':'#FF9800','pink':'#E91E63','purple':'#9C27B0','brown':'#6F4E37',
          'grey':'#9E9E9E','gray':'#9E9E9E','navy':'#1B2A4A','beige':'#D4C5A9','cream':'#F5E6CA',
          'ivory':'#FFFFF0','camel':'#C19A6B','tan':'#D2B48C','taupe':'#8B8378','khaki':'#C3B091',
          'cognac':'#9A463D','burgundy':'#800020','maroon':'#800000','wine':'#722F37','rust':'#B7410E',
          'coral':'#FF7F50','salmon':'#FA8072','peach':'#FFDAB9','gold':'#D4AF37','silver':'#C0C0C0',
          'bronze':'#CD7F32','copper':'#B87333','nude':'#E8C4A2','blush':'#DE5D83','rose':'#C97586',
          'mauve':'#9F7D8C','lavender':'#B497BD','lilac':'#C8A2C8','plum':'#8E4585','indigo':'#4B0082',
          'teal':'#008080','turquoise':'#40E0D0','aqua':'#00CED1','mint':'#9DC8B0','olive':'#808000',
          'sage':'#9DAA80','forest':'#228B22','emerald':'#50C878','charcoal':'#36454F','slate':'#708090',
          'midnight':'#191970','sand':'#C2B280','stone':'#928E85','espresso':'#3C1414','chocolate':'#7B3F00',
          'coffee':'#6F4E37','mocha':'#967969','walnut':'#773F1A','natural':'#E8D4B8','bone':'#E3DAC9',
          'wheat':'#F5DEB3','champagne':'#F7E7CE','denim':'#1560BD','caramel':'#A6772E','cherry':'#DE3163',
          'mustard':'#D5A021','tobacco':'#71543F','sapphire':'#0F52BA','jade':'#00A86B','amber':'#FFBF00',
          'apricot':'#FBCEB1','azure':'#007FFF','cerulean':'#007BA7','cobalt':'#0047AB','crimson':'#DC143C',
          'cyan':'#00B7B7','ebony':'#3B2F2F','fuchsia':'#FF00FF','garnet':'#733635','jasper':'#D73B3E',
          'lemon':'#FFF44F','lime':'#32CD32','magenta':'#C71585','marine':'#01386A','onyx':'#353839',
          'opal':'#A8C3BC','pearl':'#EAE0C8','pewter':'#8B8589','platinum':'#E5E4E2','quartz':'#A6A6A6',
          'ruby':'#9B111E','scarlet':'#FF2400','sienna':'#A0522D','smoke':'#738276','steel':'#71797E',
          'terracotta':'#E2725B','titanium':'#878681','umber':'#635147','vanilla':'#F3E5AB',
          'violet':'#8B5CF6','watermelon':'#FC6C85',
          'multi':'linear-gradient(135deg,#FF1744,#FF9100,#FFEA00,#00C853,#2962FF,#AA00FF)',
          'multicolor':'linear-gradient(135deg,#FF1744,#FF9100,#FFEA00,#00C853,#2962FF,#AA00FF)',
          'rainbow':'linear-gradient(135deg,#FF1744,#FF9100,#FFEA00,#00C853,#2962FF,#AA00FF)'
        };
        var LIGHT_KEYS = ['white','cream','ivory','off white','off-white','offwhite','bone','natural','pearl','linen','snow','oat','oatmeal','vanilla','milk','baby blue','baby pink','light pink','light blue','light green','light grey','light gray','light brown'];
        function applyHex(el) {
          var raw = (el.getAttribute('data-color-name') || '').toLowerCase().trim();
          if (!raw) return;
          var hex = COLOR_HEX[raw];
          if (!hex) { var normalized = raw.replace(/[\s\-_]+/g, ' ').trim(); hex = COLOR_HEX[normalized]; }
          if (!hex) { var keys = Object.keys(COLOR_HEX).sort(function (a, b) { return b.length - a.length; }); for (var i = 0; i < keys.length; i++) { if (raw.indexOf(keys[i]) !== -1) { hex = COLOR_HEX[keys[i]]; break; } } }
          if (!hex) { var h = 0; for (var j = 0; j < raw.length; j++) { h = ((h << 5) - h) + raw.charCodeAt(j); h |= 0; } hex = 'hsl(' + (Math.abs(h) % 360) + ', 38%, 55%)'; }
          if (String(hex).indexOf('gradient') !== -1) { el.style.background = hex; } else { el.style.backgroundColor = hex; el.style.background = hex; }
          if (LIGHT_KEYS.indexOf(raw) !== -1) el.style.borderColor = '#BBB';
        }
        function colorAll() { document.querySelectorAll('.lrn-color-swatch__circle, .lrn-card-chip--color').forEach(applyHex); }
        colorAll();
        window.__lrnColorAll = colorAll;

        /* Delegated color swatch handler — works even after drawer body is swapped by AJAX */
        document.addEventListener('click', function (e) {
          var label = e.target.closest('.lrn-color-swatch');
          if (!label) return;
          if (e.target.tagName === 'INPUT') return;
          e.preventDefault();
          var cb = label.querySelector('input[type="checkbox"]');
          if (!cb) return;
          cb.checked = !cb.checked;
          label.classList.toggle('lrn-color-swatch--active', cb.checked);
          cb.dispatchEvent(new Event('change', { bubbles: true }));
        });

        /* Delegated category parent toggle (click on row = expand/collapse) */
        document.addEventListener('click', function (e) {
          var parentLabel = e.target.closest('.lrn-cat-parent');
          if (!parentLabel) return;
          if (e.target.matches('[data-cat-parent-toggle]')) return;
          var wrap = parentLabel.closest('.lrn-cat-parent-wrap');
          if (wrap) wrap.classList.toggle('lrn-cat-open');
        });
        /* Delegated parent checkbox (select all children) */
        document.addEventListener('click', function (e) {
          if (!e.target.matches('[data-cat-parent-toggle]')) return;
          e.stopPropagation();
        });
        document.addEventListener('change', function (e) {
          if (!e.target.matches('[data-cat-parent-toggle]')) return;
          var parentCb = e.target;
          var wrap = parentCb.closest('.lrn-cat-parent-wrap');
          if (!wrap) return;
          wrap.classList.add('lrn-cat-open');
          var children = wrap.querySelectorAll('.lrn-cat-child__input');
          children.forEach(function (c) { c.checked = parentCb.checked; });
          if (children.length) children[0].dispatchEvent(new Event('change', { bubbles: true }));
        });
        /* Delegated child checkbox → sync parent state */
        document.addEventListener('change', function (e) {
          if (!e.target.matches('.lrn-cat-child__input')) return;
          var cb = e.target;
          var wrap = cb.closest('.lrn-cat-parent-wrap');
          if (!wrap) return;
          var pid = cb.getAttribute('data-cat-parent-id');
          var parentCb = wrap.querySelector('[data-cat-parent-toggle="' + pid + '"]');
          if (!parentCb) return;
          var all = wrap.querySelectorAll('.lrn-cat-child__input');
          var checked = wrap.querySelectorAll('.lrn-cat-child__input:checked');
          parentCb.checked = (checked.length === all.length);
          parentCb.indeterminate = (checked.length > 0 && checked.length < all.length);
        });
        /* Auto-expand parents whose children are checked (on initial load AND after AJAX re-render) */
        function syncCatOpenState() {
          document.querySelectorAll('.lrn-cat-child__input:checked').forEach(function (cb) {
            var w = cb.closest('.lrn-cat-parent-wrap');
            if (w) w.classList.add('lrn-cat-open');
          });
          document.querySelectorAll('[data-cat-parent-toggle]').forEach(function (parentCb) {
            var wrap = parentCb.closest('.lrn-cat-parent-wrap');
            if (!wrap) return;
            var all = wrap.querySelectorAll('.lrn-cat-child__input');
            var checked = wrap.querySelectorAll('.lrn-cat-child__input:checked');
            parentCb.checked = all.length > 0 && checked.length === all.length;
            parentCb.indeterminate = checked.length > 0 && checked.length < all.length;
          });
        }
        syncCatOpenState();
        window.__lrnSyncCatOpen = syncCatOpenState;
      })();

      /* AJAX filter form */
      var form = document.getElementById('LrnCollectionFiltersForm');
      if (form) {
        var cleanup = function () { form.querySelectorAll('input[type="number"]').forEach(function (n) { if (!n.value) n.removeAttribute('name'); }); };
        var inFlight = null, debounceTimer = null;
        function tagHandle(t) { return String(t).toLowerCase().replace(/[^\w\s-]/g, '').replace(/\s+/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, ''); }
        function applyFilters() {
          cleanup();
          /* Collect ALL form data as query params (no special tag-in-path hack).
             Shopify's Search & Discovery filters use ?filter.p.tag=xxx directly. */
          var params = new URLSearchParams(new FormData(form));
          var clean = new URLSearchParams();
          params.forEach(function (v, k) { if (v === '' || v == null) return; clean.append(k, v); });

          /* PRESERVE preview-mode / caching params from current URL so AJAX
             hits the same theme that's being previewed. */
          var currentParams = new URLSearchParams(window.location.search);
          ['preview_theme_id', '_ab', '_fd', '_sc', 'pb'].forEach(function (k) {
            var v = currentParams.get(k);
            if (v !== null && !clean.has(k)) clean.append(k, v);
          });

          var qs = clean.toString();
          var basePath = form.getAttribute('action') || window.location.pathname;
          /* Normalize: /collections/handle[/tag-segment] → /collections/handle */
          var m = basePath.match(/^(\/collections\/[^\/?#]+)/);
          if (m) basePath = m[1];
          var fullUrl = basePath + (qs ? '?' + qs : '');
          if (inFlight) inFlight.abort();
          inFlight = new AbortController();
          window.history.replaceState({}, '', fullUrl);
          var submitBtn = form.querySelector('button[type="submit"]');
          var origSubmit = submitBtn ? submitBtn.textContent : '';
          if (submitBtn) submitBtn.textContent = 'Updating…';
          function resetBtn() { if (submitBtn) submitBtn.textContent = origSubmit; }

          /* Use Shopify's Section Rendering API — appending ?section_id=<id>
             tells Shopify to render ONLY this section (not the whole page),
             using the current template/theme. Faster + works in preview mode
             without preview_theme_id hacks. */
          var sectionId = form.getAttribute('data-lrn-section-id');
          var sectionUrl = fullUrl;
          if (sectionId) {
            sectionUrl += (sectionUrl.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + encodeURIComponent(sectionId);
          }

          fetch(sectionUrl, { signal: inFlight.signal, headers: { 'X-Requested-With': 'XMLHttpRequest' } })
            .then(function (r) {
              if (!r.ok) throw new Error('HTTP ' + r.status);
              return r.text();
            })
            .then(function (html) {
              try {
                /* Section Rendering API returns bare section HTML wrapped in
                   <div class="shopify-section shopify-section-xxx"> ... </div> */
                var wrapper = document.createElement('div');
                wrapper.innerHTML = html;

                var newGrid = wrapper.querySelector('[data-lrn-grid]');
                var oldGrid = document.querySelector('[data-lrn-grid]');
                if (!newGrid) {
                  console.warn('[lrn-collection] Section response missing [data-lrn-grid]. URL:', sectionUrl, '\nFirst 300 chars of response:', html.slice(0, 300));
                  /* No fallback navigation — user asked for pure AJAX. Just reset. */
                  resetBtn();
                  return;
                }
                if (newGrid && oldGrid) oldGrid.replaceWith(newGrid);

                var newLoadWrap = wrapper.querySelector('[data-lrn-load-wrap]');
                var oldLoadWrap = document.querySelector('[data-lrn-load-wrap]');
                if (oldLoadWrap) { if (newLoadWrap) oldLoadWrap.replaceWith(newLoadWrap); else oldLoadWrap.remove(); }
                else if (newLoadWrap) { var grid2 = document.querySelector('[data-lrn-grid]'); if (grid2) grid2.parentNode.appendChild(newLoadWrap); }

                var newToolbar = wrapper.querySelector('.lrn-toolbar');
                var oldToolbar = document.querySelector('.lrn-toolbar');
                if (newToolbar && oldToolbar) oldToolbar.replaceWith(newToolbar);

                var newMeta = wrapper.querySelector('.lrn-coll-drawer__meta');
                var oldMeta = document.querySelector('.lrn-coll-drawer__meta');
                if (newMeta && oldMeta) oldMeta.replaceWith(newMeta);

                var newFoot = wrapper.querySelector('.lrn-coll-drawer__foot');
                var oldFoot = document.querySelector('.lrn-coll-drawer__foot');
                if (newFoot && oldFoot) oldFoot.replaceWith(newFoot);

                /* Refresh the drawer BODY too so filter values (colors, sizes, tags)
                   reflect the new counts and available options — critical for filter
                   stacking (e.g. Pumps + Black should keep both checked and update
                   what other filters are still applicable). Preserves scroll position. */
                var newBody = wrapper.querySelector('.lrn-coll-drawer__body');
                var oldBody = document.querySelector('.lrn-coll-drawer__body');
                if (newBody && oldBody) {
                  var scrollTop = oldBody.scrollTop;
                  /* Preserve which <details> blocks are open */
                  var openBlocks = [];
                  oldBody.querySelectorAll('details[open]').forEach(function (d, i) { openBlocks.push(i); });
                  oldBody.replaceWith(newBody);
                  /* Restore open state */
                  var freshDetails = document.querySelectorAll('.lrn-coll-drawer__body details');
                  openBlocks.forEach(function (i) { if (freshDetails[i]) freshDetails[i].setAttribute('open', ''); });
                  /* Restore scroll */
                  var freshBody = document.querySelector('.lrn-coll-drawer__body');
                  if (freshBody) freshBody.scrollTop = scrollTop;
                }

                /* Re-wire event listeners onto the swapped nodes */
                document.querySelectorAll('[data-coll-open]').forEach(function (b) { b.addEventListener('click', open); });
                document.querySelectorAll('[data-coll-close]').forEach(function (b) { b.addEventListener('click', close); });
                bindViewSwitch();
                bindLoadMore();
                if (typeof window.__lrnRenderCatChip === 'function') window.__lrnRenderCatChip();
                if (typeof window.__lrnColorAll === 'function') window.__lrnColorAll();
                if (typeof window.__lrnInterleave === 'function') window.__lrnInterleave();
                if (typeof window.__lrnSyncCatOpen === 'function') window.__lrnSyncCatOpen();
              } catch (err) {
                console.error('[lrn-collection] Error updating section:', err);
              }
              resetBtn();
            }).catch(function (err) {
              if (err.name === 'AbortError') return;
              console.error('[lrn-collection] Fetch failed:', err);
              resetBtn();
            });
        }
        form.addEventListener('change', function (e) {
          if (!e.target.matches('input[type="checkbox"], input[type="number"]')) return;
          clearTimeout(debounceTimer);
          debounceTimer = setTimeout(applyFilters, e.target.type === 'number' ? 400 : 0);
        });
        form.addEventListener('submit', function (e) { e.preventDefault(); close(); });
      }
      function bindViewSwitch() {
        var freshBtns = document.querySelectorAll('.lrn-view-btn');
        var freshGrid = document.querySelector('.lrn-coll-grid');
        freshBtns.forEach(function (b) {
          b.addEventListener('click', function () {
            var cols = b.getAttribute('data-cols');
            freshBtns.forEach(function (x) { x.classList.remove('lrn-view-btn--active'); x.style.background = 'transparent'; x.style.color = ''; });
            b.classList.add('lrn-view-btn--active'); b.style.background = '#1A1410'; b.style.color = '#FAF6F0';
            if (freshGrid) { freshGrid.setAttribute('data-cols', cols); freshGrid.style.gridTemplateColumns = 'repeat(' + cols + ', 1fr)'; }
          });
        });
      }
      function bindLoadMore() { if (typeof window.__lrnSetupLoadMore === 'function') window.__lrnSetupLoadMore(); }
    })();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
